import { render, staticRenderFns } from "./GiftProduct.vue?vue&type=template&id=33e1919a&scoped=true"
import script from "./GiftProduct.vue?vue&type=script&lang=js"
export * from "./GiftProduct.vue?vue&type=script&lang=js"
import style0 from "./GiftProduct.vue?vue&type=style&index=0&id=33e1919a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e1919a",
  null
  
)

export default component.exports